<template>
  <div>
    <v-spacer></v-spacer>
    <v-card class="mt-3">
      <v-card-title>
        <v-text-field v-model="search" placeholder="Search..."></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="locations.records"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="totalRecords"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
        }"
        :search="search"
        transition="scale-transition"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title
              ><h4 class="text-md-h4 primary--text">
                Locations
              </h4></v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="1024px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="mx-2" color="secondary" small v-bind="attrs" v-on="on">Bulk Location Upload</v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">Bulk Location Upload</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <base-location-bulk-create />
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-btn color="secondary" small @click="$router.push('/admin/location/0/edit')">New Location</v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.name="{ item }">
          <h4 color="primary">
            <router-link :to="'/admin/location/' + item.id">{{ item.name }}</router-link>
          </h4>
        </template>
        <template v-slot:item.type="{ item }">
          <v-chip label small dark>{{ item.type.toUpperCase() }}</v-chip>
        </template>
        <template v-slot:item.createdByUsername="{ item }">
          <v-chip label small dark color="primary">{{
            item.createdByUsername ? item.createdByUsername.toUpperCase() : 'User missing or deleted'
          }}</v-chip>
        </template>
        <template v-slot:item.location="{ item }">
          <a
            v-if="getGoogleMapsUrl(item)"
            :href="getGoogleMapsUrl(item)"
            target="_blank"
            rel="noopener noreferrer"
            class="coordinates-link"
          >
            <v-icon x-small color="primary" class="mr-1">mdi-map-marker</v-icon>
            {{ formatCoordinates(item) }}
          </a>
          <span v-else>Not specified</span>
        </template>
        <template v-slot:item.createdAt="{ item }">
          <h5 color="primary">{{ item.createdAt | getFormattedDate }}</h5>
        </template>
        <template v-slot:item.updatedAt="{ item }">
          <h5 color="primary">{{ item.updatedAt | getFormattedDate }}</h5>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon color="primary" small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon color="error" small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { gql } from 'apollo-boost';

// import { mapState } from 'vuex'
export default {
  data() {
    return {
      headers: [
        {
          text: 'Name',
          align: 'start',
          value: 'name',
        },
        {
          text: 'Description',
          align: 'start',
          value: 'description',
        },
        {
          text: 'Category',
          align: 'start',
          value: 'categoryName',
        },
        {
          text: 'Address',
          align: 'start',
          value: 'fullAddress',
        },
        {
          text: 'Coordinates',
          align: 'start',
          value: 'location',
        },
        { text: 'Created By', value: 'createdByUsername' },
        { text: 'Created Date', value: 'createdAt' },
        { text: 'Updated Date', value: 'updatedAt' },
        { text: 'Actions', align: 'right', sortable: false, value: 'actions' },
      ],
      search: '',
      locations: [],
      totalRecords: 0,
      isLoading: false,
      dialog: false,
      options: null,
    };
  },
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    locations: {
      query: gql`
        query Locations($limit: Int!, $skip: Int!, $query: JSON!) {
          locations(limit: $limit, skip: $skip, query: $query) {
            records {
              id
              name
              description
              category
              categoryName
              fullAddress
              location
              createdByUsername
              createdBy
              createdAt
              updatedAt
            }
            count
          }
        }
      `,
      skip() {
        return !this.me || !this.options;
      },
      variables() {
        const self = this;
        const limit = self.options.itemsPerPage;
        const skip = (self.options.page - 1) * limit;
        const searchQuery = this.search;
        return {
          limit: limit,
          skip: skip,
          query: { searchQuery: searchQuery },
        };
      },
      result({ data }, key) {
        console.log('yeah data appeared', data);
        this.totalRecords = data.locations.count;
      },
      watchLoading(isLoading, countModifier) {
        this.isLoading = isLoading;
      },
    },
  },
  created() {
    // this.$eventHub.$on("refresh-invetory-item-view", this.refresh);
  },
  watch: {
    dialog(newValue, oldValue) {
      if (!newValue) {
        this.refresh();
      }
    },
  },
  methods: {
    editItem(item) {
      this.$router.push(`/admin/location/${item.id}/edit`);
    },
    deleteItem(item) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#b3a369',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then(async result => {
        if (result.value) {
          try {
            const response = await this.$apollo.mutate({
              mutation: gql`
                mutation($id: ID!) {
                  deleteLocation(id: $id) {
                    id
                    deleted
                  }
                }
              `,
              variables: {
                id: item.id,
              },
            });

            if (response) {
              this.$swal('Success!', 'Location was successfully deleted', 'success');
              this.$router.go(this.$route.currentRoute);
            }
          } catch (e) {
            console.log(`Deletion Failed ${JSON.stringify(e)}`);
          }
        }
      });
    },
    refresh() {
      this.$router.go(this.$route.currentRoute);
    },
    getCoordinates(item) {
      const coordinates = item && item.location && item.location.coordinates;
      if (!Array.isArray(coordinates) || coordinates.length < 2) return null;

      const longitude = Number(coordinates[0]);
      const latitude = Number(coordinates[1]);
      if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;

      return { latitude, longitude };
    },
    formatCoordinates(item) {
      const coordinates = this.getCoordinates(item);
      if (!coordinates) return '';

      return `${coordinates.latitude.toFixed(6)}, ${coordinates.longitude.toFixed(6)}`;
    },
    getGoogleMapsUrl(item) {
      const coordinates = this.getCoordinates(item);
      if (!coordinates) return '';

      return `https://www.google.com/maps/search/?api=1&query=${coordinates.latitude},${coordinates.longitude}`;
    },
  },
};
</script>

<style lang="scss" scoped></style>
